import { TABLE_HEADER_HEIGHT } from 'foundations-components/transitional/constants';
export const DEFAULT_COLUMN_MINIMUM_WIDTH = 100;
export const MINIMUM_RESIZABLE_COLUMN_WIDTH = 60;
export const DEFAULT_COLUMN_WIDTH = 250;
export const SELECTION_COLUMN_WIDTH = 45;
export const TABLE_TOP_BAR_HEIGHT = TABLE_HEADER_HEIGHT;
export const TABLE_PAGINATOR_HEIGHT = 52;
export const TABLE_ROW_HEIGHT = 40;
// The min-content non-empty table consists of the header plus one row
export const TABLE_NON_EMPTY_MIN_CONTENT_HEIGHT = parseInt(TABLE_HEADER_HEIGHT, 10) + TABLE_ROW_HEIGHT;